import script from "./AppBarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBarView.vue?vue&type=script&setup=true&lang=ts"

import "./AppBarView.vue?vue&type=style&index=0&id=10ea6ef9&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ea6ef9"]])

export default __exports__